import React, { useEffect, useState, useRef } from "react";
import {
  I2cDivider,
  I2cAccordion,
  I2cIconButton,
} from "@webcomponents/i2cwebcomponents/dist/react";
import ProgramInformationOverview from "./ProgramInformationOverview";
import ProjectInformationOverview from "./ProjectInformationOverview";
import CompanyProfileOverview from "./CompanyProfileOverview";
import CardNetworkAndBinInfoOverview from "./CardNetworkAndBinInfoOverview";
import ChannelsOverview from "./ChannelsOverview";
import ProgramFeaturesOverview from "./ProgramFeaturesOverview";
import OptionalFeaturesOverview from "./OptionalFeaturesOverview";
import InterfacesAndComponentsOverview from "./InterfacesAndComponentsOverview";
import AdditionalCommentsOverview from "./AdditionalCommentsOverview";
import ProgramFeaturesCreditOverview from "./ProgramFeaturesCredit/index";
import SignoffOverview from "./SignoffOverview";
// import ACH from "./AutomatedClearingHouse";
// import MobileTextMessage from "./MobileTextMessage";
// import SSRP from "./NightlyFiles";

const ReviewSummary = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  setActiveStep,
  signatureFormData,
  showFormSignature,
  type = "debit",
}) => {
  const clientUser = localStorage.getItem("role") === "client" ?? false;
  const css = `  .accordion-group-example I2cAccordion:not(:last-of-type) {
        margin-bottom: var(--i2c-spacing-2x-small);
    `;
  useEffect(() => {
    handleAccordion();
  }, []);

  function handleAccordion() {
    const container = document.querySelector(".accordion-group-example");
    container.addEventListener("i2c-show", (event) => {
      const accordion = container.querySelectorAll("i2c-accordion");
      for (let i = 0; i < accordion.length; i++) {
        if (accordion[i] !== event.target) {
          accordion[i].open = false;
        }
      }
    });
  }
  return (
    <React.Fragment>
      <div className="App">
        <div className="accordion-group-example" style={{ width: "100%" }}>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="12">
              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Program Information"
                variant="striped"
                style={{ width: "100%", "--accordion-bg": "var(--bg-primary)" }}
              >
                <ProgramInformationOverview
                  type={type}
                  data={addFormData["0"]}
                />
                <span slot="suffix">
                  <I2cIconButton
                    onClick={() => setActiveStep(0, 0)}
                    name="linear-edit-2"
                    label="Edit"
                    style={{ fontSize: "var(--i2c-font-size-text-md)" }}
                  />
                </span>
              </I2cAccordion>

              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Project Information"
                variant="striped"
                style={{ width: "100%", "--accordion-bg": "var(--bg-primary)" }}
              >
                <ProjectInformationOverview data={addFormData["1"]} />
                <span slot="suffix">
                  <I2cIconButton
                    onClick={() => setActiveStep(1, 0)}
                    name="linear-edit-2"
                    label="Edit"
                    style={{ fontSize: "var(--i2c-font-size-text-md)" }}
                  />
                </span>
              </I2cAccordion>

              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Company Profile"
                variant="striped"
                style={{ width: "100%", "--accordion-bg": "var(--bg-primary)" }}
              >
                <CompanyProfileOverview data={addFormData["2"]} type={type} />
                <span slot="suffix">
                  <I2cIconButton
                    onClick={() => setActiveStep(2, 0)}
                    name="linear-edit-2"
                    label="Edit"
                    style={{ fontSize: "var(--i2c-font-size-text-md)" }}
                  />
                </span>
              </I2cAccordion>
              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Card Network And Bin Info"
                variant="striped"
                style={{ width: "100%", "--accordion-bg": "var(--bg-primary)" }}
              >
                <CardNetworkAndBinInfoOverview data={addFormData["3"]} />
                <span slot="suffix">
                  <I2cIconButton
                    onClick={() => setActiveStep(3, 0)}
                    name="linear-edit-2"
                    label="Edit"
                    style={{ fontSize: "var(--i2c-font-size-text-md)" }}
                  />
                </span>
              </I2cAccordion>

              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Channels"
                variant="striped"
                style={{ width: "100%", "--accordion-bg": "var(--bg-primary)" }}
              >
                <ChannelsOverview data={addFormData["4"]} />
                <span slot="suffix">
                  <I2cIconButton
                    onClick={() => setActiveStep(4, 0)}
                    name="linear-edit-2"
                    label="Edit"
                    style={{ fontSize: "var(--i2c-font-size-text-md)" }}
                  />
                </span>
              </I2cAccordion>

              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Program Features"
                variant="striped"
                style={{ width: "100%", "--accordion-bg": "var(--bg-primary)" }}
              >
                {type === "credit" ? (
                  <ProgramFeaturesCreditOverview data={addFormData["5"]} />
                ) : (
                  <ProgramFeaturesOverview data={addFormData["5"]} />
                )}
                <span slot="suffix">
                  <I2cIconButton
                    onClick={() => setActiveStep(5, 0)}
                    name="linear-edit-2"
                    label="Edit"
                    style={{ fontSize: "var(--i2c-font-size-text-md)" }}
                  />
                </span>
              </I2cAccordion>

              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Optional Features"
                variant="striped"
                style={{ width: "100%", "--accordion-bg": "var(--bg-primary)" }}
              >
                <OptionalFeaturesOverview data={addFormData["6"]} />
                <span slot="suffix">
                  <I2cIconButton
                    onClick={() => setActiveStep(6, 0)}
                    name="linear-edit-2"
                    label="Edit"
                    style={{ fontSize: "var(--i2c-font-size-text-md)" }}
                  />
                </span>
              </I2cAccordion>
              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Interfaces and Components"
                variant="striped"
                style={{ width: "100%", "--accordion-bg": "var(--bg-primary)" }}
              >
                <InterfacesAndComponentsOverview data={addFormData["7"]} />
                <span slot="suffix">
                  <I2cIconButton
                    onClick={() => setActiveStep(7, 0)}
                    name="linear-edit-2"
                    label="Edit"
                    style={{ fontSize: "var(--i2c-font-size-text-md)" }}
                  />
                </span>
              </I2cAccordion>
              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Additional Comments"
                variant="striped"
                style={{ width: "100%", "--accordion-bg": "var(--bg-primary)" }}
              >
                <AdditionalCommentsOverview data={addFormData["8"]} />
                <span slot="suffix">
                  <I2cIconButton
                    onClick={() => setActiveStep(8, 0)}
                    name="linear-edit-2"
                    label="Edit"
                    style={{ fontSize: "var(--i2c-font-size-text-md)" }}
                  />
                </span>
              </I2cAccordion>
              {showFormSignature ? (
                <I2cAccordion
                  iconStyle="custom"
                  iconClose="cs-linear-chevron-down"
                  iconOpen="cs-linear-chevron-up"
                  summary="Client Signoff"
                  variant="striped"
                  style={{
                    width: "100%",
                    "--accordion-bg": "var(--bg-primary)",
                  }}
                >
                  <SignoffOverview data={signatureFormData} />
                  {clientUser && (
                    <span slot="suffix">
                      <I2cIconButton
                        onClick={() => setActiveStep(9, 1)}
                        name="linear-edit-2"
                        label="Edit"
                        style={{ fontSize: "var(--i2c-font-size-text-md)" }}
                      />
                    </span>
                  )}
                </I2cAccordion>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ReviewSummary;
